import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useModalFromQuery(
  key: string,
  setOpen: (value: boolean) => void
) {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get(key) === 'true') {
      setOpen(true);
    }
  }, [key, searchParams, setOpen]);

  const close = () => {
    setOpen(false);

    const params = new URLSearchParams(searchParams);
    params.delete(key);

    setSearchParams(params, { replace: true });
  };

  return { close };
}
